import { useEffect } from "react";

export const useHistoryReset = () => {
    useEffect(() => {
        const handleBeforeUnload = () =>
            window.history.replaceState({}, '');

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, []);
};

export default useHistoryReset;
